module.exports = __webpack_public_path__ + "img/Avatar-16.c9347523.svg";